import { useState } from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { memberships } from "@/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";
import EmailCheckoutModal from "@/components/EmailCheckoutModal";

const LOOKUP = { care: "care_monthly", growth: "growth_monthly", pro: "pro_monthly" };

const Memberships = () => {
  const [modalPlan, setModalPlan] = useState(null);
  return (
    <>
    <section id="plans" className="py-24 md:py-32 bg-[#0a0a0a] border-y border-white/10" data-testid="memberships">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="mb-14 md:mb-20 max-w-3xl">
          <p className="text-[#ff0055] text-xs font-semibold uppercase tracking-widest mb-4">Keep growing</p>
          <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight mb-6">
            Launched. Looked after. Growing.
          </h2>
          <p className="text-lg text-zinc-400">
            Once you're live, our monthly care plans keep everything running, updated and getting you more customers.
            Cancel anytime.
          </p>
        </motion.div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid md:grid-cols-3 gap-6" data-testid="memberships-grid">
          {memberships.map((m) => (
            <motion.div
              key={m.id}
              variants={fadeUp}
              whileHover={{ y: -8 }}
              className={`rounded-2xl p-8 flex flex-col ${m.highlight ? "bg-[#121212] border border-[#ff0055]/50 pink-glow" : "bg-[#0f0f0f] border border-white/10"}`}
              data-testid={`membership-${m.id}`}
            >
              {m.highlight && <span className="self-start rounded-full bg-[#ff0055]/20 text-[#ff0055] text-[10px] font-bold uppercase tracking-widest px-3 py-1 mb-4">Best value</span>}
              <h3 className="font-display font-bold text-xl mb-4">{m.name}</h3>
              <div className="flex items-end gap-1 mb-6">
                <span className="font-display font-black text-5xl">{m.price}</span>
                <span className="text-zinc-500 mb-2">{m.per}</span>
              </div>
              <ul className="flex flex-col gap-3 mb-8 flex-1">
                {m.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-zinc-300">
                    <Check size={16} className={`mt-0.5 shrink-0 ${m.highlight ? "text-[#ff0055]" : "text-[#ccff00]"}`} />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => setModalPlan({ name: m.name, price: `${m.price}${m.per}`, lookup: LOOKUP[m.id] })}
                className={`rounded-full font-bold uppercase tracking-widest text-xs py-3.5 transition-transform hover:scale-105 flex items-center justify-center gap-2 ${m.highlight ? "bg-[#ff0055] text-white" : "border border-white/20 text-white hover:bg-white/5"}`}
                data-testid={`membership-cta-${m.id}`}
              >
                Get {m.name}
              </button>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
    {modalPlan && <EmailCheckoutModal product={modalPlan} onClose={() => setModalPlan(null)} />}
    </>
  );
};

export default Memberships;
